import { IConfigGeralModulos } from "../../../Interfaces/Geral/ConfigGeral/ConfigGeral";
import {
    AtualizarConfigModuloService,
    GetConfigModuloService,
    ListConfigModuloService,
} from "../../../Services/Geral/ConfigGeral/ConfigGeralService";
import { Controller } from "../../Controller";

export async function AtualizarConfigModuloController(
    requestBody: IConfigGeralModulos
) {
    return Controller(AtualizarConfigModuloService(requestBody));
}

export async function GetConfigModuloController(idModulo: number) {
    return Controller(GetConfigModuloService(idModulo));
}

export async function ListConfigModuloController() {
    return Controller(ListConfigModuloService());
}
